// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  
  .chatbot-messages {
    /* max-height: 70vh;  */
    overflow-y: auto;
    padding: 10px;
  }
  .message {
    margin-bottom: 10px;
    padding: 5px 10px;
    border-radius: 5px;
  }
  
  .bot {
    background-color: #f0f0f0;
  }
  
  .user {
    background-color: #e3f2fd;
  }
  
  .chatbot-input-form {
    display: flex;
    align-items: center;
    padding: 10px;
  }
  
  .chatbot-input-form input {
    flex: 1 1;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 20px;
    margin-right: 10px;
    box-sizing: border-box; /* Include padding and border in the width */
  }
  
  .chatbot-input-form button {
    padding: 8px 15px;
    border: none;
    background-color: #007bff;
    color: #fff;
    border-radius: 20px;
    cursor: pointer;
  }
  
  .chatbot-input-form button:hover {
    background-color: #0056b3;
  }
  
  body {
    margin: 0; /* Remove default margin */
    padding: 0; /* Remove default padding */
    
  }
  
  .chatbot-page-container {
    width: 80%; /* Adjust width as needed */
    max-width: 1200px;
    height: 90vh; /* Adjust height using viewport height units */
    max-height: 90vh; /* Set maximum height using viewport height units */
    border: 1px solid #ccc;
    border-radius: 5px;
    overflow: hidden;
    margin: auto; /* Center the chatbot container */
    
  }
  
  @keyframes typing {
    0% {
      width: 0;
    }
    50% {
      width: 20px;
    }
    100% {
      width: 0;
    }
  }
  
  .typing-animation::after {
    content: '|';
    display: inline-block;
    animation: typing 1s infinite;
  }
  
  
  /* Rest of the CSS remains the same */
  `, "",{"version":3,"sources":["webpack://./src/chat.css"],"names":[],"mappings":";EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB,EAAE,4CAA4C;EACtE;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,SAAS,EAAE,0BAA0B;IACrC,UAAU,EAAE,2BAA2B;;EAEzC;;EAEA;IACE,UAAU,EAAE,2BAA2B;IACvC,iBAAiB;IACjB,YAAY,EAAE,8CAA8C;IAC5D,gBAAgB,EAAE,mDAAmD;IACrE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY,EAAE,iCAAiC;;EAEjD;;EAEA;IACE;MACE,QAAQ;IACV;IACA;MACE,WAAW;IACb;IACA;MACE,QAAQ;IACV;EACF;;EAEA;IACE,YAAY;IACZ,qBAAqB;IACrB,6BAA6B;EAC/B;;;EAGA,qCAAqC","sourcesContent":["  \n  .chatbot-messages {\n    /* max-height: 70vh;  */\n    overflow-y: auto;\n    padding: 10px;\n  }\n  .message {\n    margin-bottom: 10px;\n    padding: 5px 10px;\n    border-radius: 5px;\n  }\n  \n  .bot {\n    background-color: #f0f0f0;\n  }\n  \n  .user {\n    background-color: #e3f2fd;\n  }\n  \n  .chatbot-input-form {\n    display: flex;\n    align-items: center;\n    padding: 10px;\n  }\n  \n  .chatbot-input-form input {\n    flex: 1;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 20px;\n    margin-right: 10px;\n    box-sizing: border-box; /* Include padding and border in the width */\n  }\n  \n  .chatbot-input-form button {\n    padding: 8px 15px;\n    border: none;\n    background-color: #007bff;\n    color: #fff;\n    border-radius: 20px;\n    cursor: pointer;\n  }\n  \n  .chatbot-input-form button:hover {\n    background-color: #0056b3;\n  }\n  \n  body {\n    margin: 0; /* Remove default margin */\n    padding: 0; /* Remove default padding */\n    \n  }\n  \n  .chatbot-page-container {\n    width: 80%; /* Adjust width as needed */\n    max-width: 1200px;\n    height: 90vh; /* Adjust height using viewport height units */\n    max-height: 90vh; /* Set maximum height using viewport height units */\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    overflow: hidden;\n    margin: auto; /* Center the chatbot container */\n    \n  }\n  \n  @keyframes typing {\n    0% {\n      width: 0;\n    }\n    50% {\n      width: 20px;\n    }\n    100% {\n      width: 0;\n    }\n  }\n  \n  .typing-animation::after {\n    content: '|';\n    display: inline-block;\n    animation: typing 1s infinite;\n  }\n  \n  \n  /* Rest of the CSS remains the same */\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
